module.exports = __webpack_public_path__ + "static/media/AlumniApplication.ce1848bd.pdf";